import React, { useState } from "react";
import { useForm } from "react-hook-form";
import SegmentedControl, {
	SegmentedControlController,
	SegmentedControlOption,
} from "./SegmentedControl";

// Mirrors the customer-type selector from the design reference.
const CUSTOMER_TYPE_OPTIONS: SegmentedControlOption[] = [
	{ value: "company", label: "Företag" },
	{ value: "concern", label: "Företag i koncern" },
	{ value: "private", label: "Privatperson" },
];

const VIEW_OPTIONS: SegmentedControlOption[] = [
	{ value: "list", label: "List" },
	{ value: "board", label: "Board" },
	{ value: "calendar", label: "Calendar", disabled: true },
];

const SegmentedControlExample: React.FC = () => {
	const [customerType, setCustomerType] = useState("company");
	const [view, setView] = useState("list");
	const [period, setPeriod] = useState("month");

	const { control, handleSubmit } = useForm({
		defaultValues: { customerType: "company" },
	});

	const onSubmit = (data: any) => alert(JSON.stringify(data, null, 2));

	return (
		<div className="max-w-xl space-y-8 p-6">
			<h3 className="text-lg font-semibold">SegmentedControl Component Examples</h3>

			{/* The design reference */}
			<div>
				<h4 className="text-md mb-2 font-medium">Default — the design reference</h4>
				<SegmentedControl
					options={CUSTOMER_TYPE_OPTIONS}
					value={customerType}
					onChange={setCustomerType}
					skipTranslation
				/>
				<p className="mt-2 text-sm text-gray-600">Selected: {customerType}</p>
			</div>

			{/* With group label + mandatory */}
			<div>
				<h4 className="text-md mb-2 font-medium">With label + mandatory</h4>
				<SegmentedControl
					label="Kundtyp"
					mandatory
					options={CUSTOMER_TYPE_OPTIONS}
					value={customerType}
					onChange={setCustomerType}
					skipTranslation
				/>
			</div>

			{/* Small size + a disabled segment */}
			<div>
				<h4 className="text-md mb-2 font-medium">Small size &amp; disabled segment</h4>
				<SegmentedControl
					size="sm"
					options={VIEW_OPTIONS}
					value={view}
					onChange={setView}
					skipTranslation
				/>
				<p className="mt-2 text-sm text-gray-600">Selected: {view}</p>
			</div>

			{/* Full width */}
			<div>
				<h4 className="text-md mb-2 font-medium">Full width</h4>
				<SegmentedControl
					fullWidth
					options={[
						{ value: "day", label: "Day" },
						{ value: "week", label: "Week" },
						{ value: "month", label: "Month" },
					]}
					value={period}
					onChange={setPeriod}
					skipTranslation
				/>
			</div>

			{/* Error state */}
			<div>
				<h4 className="text-md mb-2 font-medium">Error state</h4>
				<SegmentedControl
					label="Kundtyp"
					mandatory
					options={CUSTOMER_TYPE_OPTIONS}
					value=""
					onChange={() => {}}
					errors="Detta fält är obligatoriskt"
					skipTranslation
				/>
			</div>

			{/* Disabled whole control */}
			<div>
				<h4 className="text-md mb-2 font-medium">Disabled</h4>
				<SegmentedControl
					options={CUSTOMER_TYPE_OPTIONS}
					value="company"
					onChange={() => {}}
					disabled
					skipTranslation
				/>
			</div>

			{/* React Hook Form integration */}
			<div>
				<h4 className="text-md mb-4 font-medium">React Hook Form Integration</h4>
				<form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
					<SegmentedControlController
						control={control}
						name="customerType"
						label="Kundtyp"
						options={CUSTOMER_TYPE_OPTIONS}
						mandatory
						skipTranslation
					/>
					<button type="submit" className="rounded bg-action px-4 py-2 text-white hover:opacity-90">
						Submit Form
					</button>
				</form>
			</div>
		</div>
	);
};

export default SegmentedControlExample;
